export default __webpack_public_path__ + "static/media/jaydev.031ab1e4.png";